import { createContext, useContext } from 'react'

export const DisablePortalContext = createContext<boolean>(false)

export const useDisablePortalContext = () => useContext(DisablePortalContext)
